import FormSet from '../../../../types/api/form-set'
import { FormsTableRow } from '../types/forms-table-row'

export function FormsDataSource(formSets: FormSet[]): FormsTableRow[] {
    return formSets.flatMap(set => {
        const forms = set.forms ?? []
        const count = forms.length
        const setFields = {
            setId: set.id,
            setDocumentId: set.documentId,
            formsCount: count,
        }

        if (count === 0) {
            return [
                {
                    key: `${set.documentId}-empty`,
                    rowSpan: 1,
                    ...setFields,
                },
            ]
        }

        return forms.map((form, index) => ({
            key: `${set.documentId}-${form.documentId}`,
            rowSpan: index === 0 ? count : 0,
            ...setFields,
            formDocumentId: form.documentId,
            num: form.num,
            color: form.color,
            colorName: form.colorName,
            inStock: form.inStock,
            failureReason: form.failureReason,
            dateOfFailure: form.dateOfFailure,
            form_order: form.form_order,
        }))
    })
}
